import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { CollectionForm } from "app/interfaces/collection-form.interface";

const collectionsUrlApi = environment.collectionsUrlApi;
const collectionsOwnerUrlApi = environment.collectionsOwnerUrlApi;
const collectionIncidentUrlApi = environment.collectionIncidentUrlApi;
const getCollectionsListIncidentExcluded =
  environment.getCollectionsListIncidentExcluded;

@Injectable()
export class CollectionService {
  public collection: CollectionForm;

  constructor(private http: HttpClient) {}

  getCollections() {
    return this.http
      .request("GET", `${collectionsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getOwnCollections() {
    return this.http
      .request("GET", `${collectionsOwnerUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getCollectionById(id: number) {
    return this.http
      .request("GET", `${collectionsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getCollectionForAddIncidentExcluded(id: number) {
    return this.http
      .request("GET", `${getCollectionsListIncidentExcluded}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  updateCollectionById(id: number, collectionModel: CollectionForm) {
    console.log(id);
    console.log(collectionModel);
    const body = collectionModel;
    return this.http
      .request("PUT", `${collectionsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createCollection(collectionModel: CollectionForm) {
    console.log(collectionModel);
    const body = collectionModel;
    return this.http
      .request("POST", `${collectionsUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteCollectionById(id: number) {
    return this.http
      .request("DELETE", `${collectionsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  // collection/incident
  getCollectionIncidents(id: number) {
    return this.http
      .request("GET", `${collectionIncidentUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  createCollectionIncident(idIncident: number, idCollection: number) {
    const body = { id_incident: idIncident, id_collection: idCollection };
    return this.http
      .request("POST", `${collectionIncidentUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteIncidentCollectionById(id: number) {
    return this.http
      .request("DELETE", `${collectionIncidentUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
}
